// AuthConstants.js

export const IsLoggedIn = 'isLoggedIn';
export const Token = 'token';
export const Features = 'features';
// ... define other routes as needed